var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 235,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.695 199.559H188.735l-1.098-1.914c-6.882 13.842-16.484 25.757-29.448 34.333-.825.545-.871 2.134.304 2.325 18.392 3.001 38.381-4.79 52.743-15.729 6.717-5.116 12.426-11.352 17.527-18.05.905-1.189.65-.965 2.693-.965h34.209c.693 0 1.272-.579 1.272-1.272V1.694c0-.693-.579-1.272-1.272-1.272H1.694C1.001.422.422 1 .422 1.694v196.593c0 1.641 2.544 1.641 2.544 0V1.694L1.694 2.966h263.971l-1.272-1.272v196.593l1.272-1.272h-36.437c-1.461 0-1.795 1.039-2.663 2.224-3.169 4.328-6.811 8.295-10.669 12.013-14.143 13.63-36.679 23.87-56.728 20.598l.304 2.325c13.324-8.812 23.282-21.005 30.361-35.246.422-.846-.084-1.914-1.098-1.914H1.695c-1.64 0-1.64 2.544 0 2.544Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogFrame);
export default __webpack_public_path__ + "static/media/dialog_frame.a841ca6ec5a01a53ea8affdde5e6ef84.svg";
export { ForwardRef as ReactComponent };